import type { ReactNode } from 'react';

import React from 'react';

import useClassy from '@core/hooks/useClassy';

import classes from './style.module.scss';

interface KbdShortcutProps extends React.HTMLAttributes<HTMLElement> {
  children: ReactNode;
  className?: string;
}

const KbdShortcut = ({ children, className, ...props }: KbdShortcutProps) => {
  const bem = useClassy(classes, 'KbdShortcut');

  return (
    <kbd className={bem('&', className)} {...props}>
      {children}
    </kbd>
  );
};

export default KbdShortcut;
